export default __webpack_public_path__ + "static/media/04-3.0b74c810.jpg";